export const STATUS_REVIEWED = 'REVIEWED';
export const STATUS_UNREVIEWED = 'UNREVIEWED';

export const STATUS = [STATUS_UNREVIEWED, STATUS_REVIEWED];
